<template>
  <div>
    <AlertDismiss ref="alertDismiss"></AlertDismiss>
    <b-form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-md-6 mb-3">
          <b-form-group label="Nombre">
            <b-form-input
                v-model="name"
                :state="validate(name)"
            />
          </b-form-group>
        </div>

        <div class="col-md-6 mb-3">
          <RUTInput v-model="rut" :state="validate(rut)"></RUTInput>
        </div>

        <div class="col-6 col-sm-2 mt-3 align-items-center" >
          <b-button
              type="submit"
              variant="outline-primary"
              :disabled="isUploading"
          >
            <b-spinner small v-show="isUploading"></b-spinner>
            Actualizar
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script>
import RUTInput from "@/components/shared/RUT-input.vue";
import { mapActions } from 'vuex';
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";
import { EventNames } from "@/plugins/enums";

export default {
  name: 'ShareholderEditPersonForm',

  components: {
    AlertDismiss,
    RUTInput
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      id: this.item.id,
      name: this.item.name,
      rut: this.item.rut,

      isUploading: false,
      attemptedSubmit: false,
      showProgress: false
    }
  },

  methods: {
    ...mapActions(["editSubject"]),

    async onSubmit() {
      this.isUploading = true;
      await this.updateForm()
      this.isUploading = false;
    },

    async updateForm() {

      let data = {
        id: this.id,
        name: this.name,
        rut: this.rut,
      }

      let result = await this.editSubject(data);

      if (result.isError) {
        this.$refs.alertDismiss.showAlert(result.message, 'danger');
        this.isUploading = false;
        this.attemptedSubmit = true;
        return;
      }

      this.$refs.alertDismiss.showAlert( 'Datos actualizados correctamente', 'success' );
      this.$eventBus.$emit(EventNames.UpdateLegalEntities);

      this.isUploading = false;
      this.attemptedSubmit = false;
    },

    validate(value) {
      if (this.attemptedSubmit && !value) {
        return false;
      }
      return null
    }
  }
}
</script>
